<template>
  <div id="app">
    <!--    <img src="./assets/logo.png">-->
    <router-view style="-moz-user-select:none; user-select: none"></router-view>
  </div>
</template>

<script>
export default {
  name:'App',
  // components: {Login},

  methods:{
    /*方法*/
  },
  mounted() { /*页面加载时调用*/
    document.title = "节能系统";
    document.getElementsByTagName("body")[0].style = "overflow: hidden;"; /*去除滚动条*/
  }
};
</script>

<style>
html, body, #app {
  height: 100vh;
  margin: 0 0 auto;
  padding: 0;
}

.el-radio-group {
  font-size: 0;
  display: inline-flex; /* 或者 flex */
}

#app .el-main {
  padding: 0;
}

.el-divider--horizontal {
  margin: 0;
}

.el-dialog {
  margin-top: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue